import { Grid } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";

interface CalendarProps {
  start: dayjs.Dayjs;
  handleDateChange: (date: dayjs.Dayjs, name: string) => void;
  name: string;
  id: string;
  message: string
}

const CalendarSelect: React.FC<CalendarProps> = ({
  start,
  handleDateChange,
  name,
  id,
  message
}) => {
  const intl = useIntl();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            name={name}
            label={intl.formatMessage({
              id: id,
              defaultMessage: message,
            })}
            value={dayjs(start)}
            onChange={(date) => handleDateChange(date!, "date")}
            sx={{ width: "100%" }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};

export default CalendarSelect;
